const UNLICENSED_ERROR = 'Unlicensed in property state'

const DEFAULT_PAYMENTS = [
  {
    apr: 6.74,
    monthly_payment: 574,
    term: 10,
  },
  {
    apr: 6.865,
    monthly_payment: 446,
    term: 15,
  },
  {
    apr: 6.865,
    monthly_payment: 384,
    term: 20,
  },
  {
    apr: 6.865,
    monthly_payment: 328,
    term: 30,
  },
]

const DEFAULT_SLIDER_CONFIG = {
  min: 1000,
  max: 100000,
  step: 1000,
  maxPlus: false,
}

const dollarUSLocale = Intl.NumberFormat('en-US')

function roundDownToNearestThousand(number, max) {
  let rounded = Math.floor(number / 1000) * 1000
  return rounded > max ? max : rounded
}

function validateApr(value, term) {
  if (!value[term - 1]?.apr) return 0
  return parseFloat(value[term - 1]?.apr).toFixed(3)
}

export {
  UNLICENSED_ERROR,
  DEFAULT_PAYMENTS,
  DEFAULT_SLIDER_CONFIG,
  dollarUSLocale,
  roundDownToNearestThousand,
  validateApr,
}
